module.exports = __webpack_public_path__ + "img/book-module-radar-info.7609ac38.png";